module.exports = __webpack_public_path__ + "img/yamada-sensei.cca55ebb.jpg";